/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
import shopManage from './router-shopManage.js'
import routerPower from './router-power'
import routerOrder from './router-order'
import routerBrand from './router-brand'
import merchantPotal from './merchantPotal'
import routerWarn from './router-warn'
import materialManagement from './router-materialManagement'
import routerUrsit from './router-ursit'
import promotion from './promotion'
import routerIframe from './router-iframe'
import violationManage from './violationManage'
import price from './price'
import goodsModel from './goodsModel'
import routerStock from './router-stock'
import electronicExpress from './router-electronicExpress'
import electronicTemplate from './router-electronicTemplate'
import priceControl from './price-control'
import rectificationReport from './rectificationReport'
import  activityRegistration from './activityRegistration'
import marketSignUp from './marketSignUp'

export default [{
  path: '/',
  name: 'POP',
  // redirect: '/index',
  component: require('../views/home/index.vue').default,
  redirect: { name: 'index' },
  children: [{
    path: 'index',
    name: 'index',
    meta: {
      title: '首页'
    },
    component: () => import(/* webpackChunkName: "pop-index" */ '../views/index/index.vue')
  },
  {
    path: 'noticeDetail',
    name: 'noticeDetail',
    meta: {
      title: '公告详情'
    },
    component: () => import(/* webpackChunkName: "pop-index" */ '../views/index/notice-detail.vue')
  },
  {
    path: 'allNotice',
    name: 'allNotice',
    meta: {
      title: '全部公告'
    },
    component: () => import(/* webpackChunkName: "pop-index" */ '../views/index/allNotice.vue')
  },
  {
    path: 'orderDelivery',
    name: 'OrderDelivery',
    meta: {
      title: '订单发货'
    },
    component: () => import(/* webpackChunkName: "pop-orderDelivery" */ '../views/orderDelivery/orderDelivery.vue')
  },
  {
    path: 'orderDetails',
    name: 'orderDetails',
    meta: {
      title: '订单发货'
    },
    component: () => import(/* webpackChunkName: "pop-orderDelivery" */ '../views/orderDelivery/orderDetails.vue')
  },
  {
    path: 'logisticsReport',
    name: 'logisticsReport',
    meta: {
      title: '物流异常上报雷达'
    },
    component: () => import('../views/logisticsReport/index.vue')
  }, {
    path: 'logisticsWarning',
    name: 'logisticsWarning',
    meta: {
      title: '物流预警'
    },
    component: () => import('../views/logisticsReport/warning.vue')
  },
  ...shopManage,
  ...routerPower,
  ...routerOrder,
  ...routerBrand,
  ...merchantPotal,
  ...routerWarn,
  ...materialManagement,
  ...routerUrsit,
  ...promotion,
  ...routerIframe,
  ...violationManage,
  ...goodsModel,
  ...routerStock,
  ...price,
  ...electronicExpress,
  ...electronicTemplate,
  ...priceControl,
  ...rectificationReport,
  ...activityRegistration,
  ...marketSignUp
  ]
},
{
  path: '/price/extranetPrice',
  name: 'extranetPrice',
  meta: {
    title: '外网价格查询'
  },
  component: (resolve) => {
    require(['@components/priceParity/extranetPrice'], resolve)
  }
},
{
  path: '/newcomer',
  name: 'newcomer',
  meta: {
    title: '新手任务'
  },
  // redirect: '/index',
  component: () => import(/* webpackChunkName: "pop-newcomer" */ '../views/newcomer/index.vue'),
  children: [{
    path: '/newcomerLogo',
    name: 'newcomerLogo',
    meta: {
      title: '新手任务欢迎页'
    },
    // redirect: '/index',
    component: () => import(/* webpackChunkName: "pop-newcomer" */ '../views/newcomer/newcomer-logo.vue')
  },
  {
    path: '/newcomerDetail',
    name: 'newcomerDetail',
    meta: {
      title: '新手任务新增'
    },
    // redirect: '/index',
    component: () => import(/* webpackChunkName: "pop-newcomer" */ '../views/newcomer/newcomer-detail.vue')
  },
  {
    path: '/newcomerSuccess',
    name: 'newcomerSuccess',
    meta: {
      title: '新手任务成功'
    },
    // redirect: '/index',
    component: () => import(/* webpackChunkName: "pop-newcomer" */ '../views/newcomer/success.vue')
  }
  ]
},

// 入驻
{
  path: '/newenter',
  name: 'newenter',
  meta: {
    title: '首页'
  },
  // redirect: '/index',
  component: () => import(/* webpackChunkName: "pop-newenter" */ '../views/newenter/index.vue')
},
{
  path: '/checkedpage',
  name: 'checkedpage',
  meta: {
    title: '首页'
  },
  // redirect: '/index',
  component: () => import(/* webpackChunkName: "pop-checkedpage" */ '../views/newenter/checked_page.vue')
},
{
  path: '/enterpage',
  name: 'enterpage',
  meta: {
    title: '首页'
  },
  // redirect: '/index',
  component: () => import(/* webpackChunkName: "pop-enterpage" */ '../views/newenter/newenter_pass.vue')
},
{
  path: '/login',
  name: 'login',
  meta: {
    title: '首页'
  },
  // redirect: '/index',
  component: () => import(/* webpackChunkName: "pop-newenter" */ '../views/login/index.vue')
},
{
  path: '/resetPassword',
  component: (resolve) => {
    require(['@/views/login/resetPassword'], resolve)
  }
},
{
  path: '/initPassword',
  component: (resolve) => {
    require(['@/views/login/initPassword'], resolve)
  }
}, {
  path: '/resetPhone',
  component: (resolve) => {
    require(['@/views/login/resetPhone'], resolve)
  }
}, {
  path: '/promotion/close',
  name: 'close',
  meta: {
    title: '合同管理签章完成'
  },
  component: () => import(/* webpackChunkName: "pop-contractManagement" */ '../views/contractManagement/components/close.vue')
},{
  name: 'sensitiveWordsOA',
  path: '/goods/sensitiveWordsOA',
  meta: {
    title: '敏感词OA审核页面'
  },
  component: () =>
    import( /* webpackChunkName: "pop-commodityRecord" */ '../views/goodsManagement/components/sensitiveWordsOA.vue')
}
]
